import { createSlice } from "@reduxjs/toolkit";

const pendingUploadsQueueSlice = createSlice({
  name: "pendingUploadsQueue",
  initialState: {
    items: [],
    message: "",
    failedCount: 0,
  },
  reducers: {
    updateQueue: (state, action) => {
      state.items = action.payload;
    },
    updateMessage: (state, action) => {
      state.message = action.payload;
    },
    updateFailedCount: (state, action) => {
      state.failedCount = action.payload; 
    },
    clearQueue: (state) => {
      state.items = [];
    },
    clearMessage: (state) => {
      state.message = "";
    },
    clearFailedCount: (state) => {
      state.failedCount = 0; 
    },
  },
});

export const { clearMessage, clearQueue, updateMessage, updateQueue, updateFailedCount, clearFailedCount } = pendingUploadsQueueSlice.actions;

const pendingUploadsQueueReducer = pendingUploadsQueueSlice.reducer;

export default pendingUploadsQueueReducer;
